const routes = [
  {
    path: 'js-closures',
    name: 'jsClosures',
    component: () => import(/* webpackChunkName: "jsClosures" */ '@/modules/js-closures/index.vue')
  },
];

export default routes;